import { render, staticRenderFns } from "./GetSourceMessage.vue?vue&type=template&id=b7a6753e&scoped=true"
import script from "./GetSourceMessage.vue?vue&type=script&lang=js"
export * from "./GetSourceMessage.vue?vue&type=script&lang=js"
import style0 from "./GetSourceMessage.vue?vue&type=style&index=0&id=b7a6753e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a6753e",
  null
  
)

export default component.exports